import axios from 'axios';
import { axiosConfig, serverUrl } from '../config';
import {
  Device,
} from '../types';

type GetDeviceInfoProps = {
  deviceId: string;
};

const createStreetsDevice = async ({ deviceId }: GetDeviceInfoProps): Promise<Device> => {
  const deviceInfo = {
    id: deviceId,
    name: `Device ${deviceId}`,
    model: window.DeviceApi?.getDeviceModel?.() ?? 'unknown',
    height: window.DeviceApi?.getDisplayHeight?.() ?? 0,
    width: window.DeviceApi?.getDisplayWidth?.() ?? 0,
  };

  try {
    const { data } = await axios.post(`${serverUrl}/external/device/pending`, deviceInfo, { ...axiosConfig });
    return data;
  } catch (error) {
    return {} as Device;
  }
};

export interface DeviceResponse {
  device?: Device;
  isPending?: boolean;
}

// Enhanced device info request that handles the new pending flow
export const getDeviceInfoRequest = async ({ deviceId }: GetDeviceInfoProps): Promise<DeviceResponse> => {
  try {
    const response = await axios.get(`${serverUrl}/external/device/${deviceId}`, { ...axiosConfig, timeout: 5000 });

    if (response.status === 202) {
      // Device is pending
      return { isPending: true };
    }

    // Status 200 - device found
    return { device: response.data };
  } catch (error) {
    if (error?.response?.status === 404) {
      // Device not found - create pending device
      try {
        await createStreetsDevice({ deviceId });
        return { isPending: true };
      } catch (createError) {
        console.error('Error creating pending device:', createError);
      }
      return {};
    }

    console.error('Unexpected error:', error);
    return {};
  }
};
